import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import cx from 'classnames';
import {
    Grid,
    Row,
    Col
} from 'react-bootstrap';
import s from './ListingBenefits.css';
import cs from '../../commonStyle.css';

// Translation
import { FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

import benefitsImage from '/images/whyhost/Listingbenefits.png';

class ListingBenefits extends Component {
    render() {
        const { data } = this.props;

        return (
            <div className={cx(s.Listingbenefits)}>
                <div className={s.container}>
                    <Row className={cx(cs.dFlex, s.flexWrap)}>
                        <Col lg={7} md={8} sm={7} xs={12}>
                            <div className={s.ListingbenefitsList}>
                                <div className={cx(s.ListingbenefitsItem)}>
                                    <h3>{data && data.benefitsTitle1}</h3>
                                    <p>{data && data.benefitsContent1}</p>
                                </div>
                                <div className={cx(s.ListingbenefitsItem)}>
                                    <h3>{data && data.benefitsTitle2}</h3>
                                    <p>{data && data.benefitsContent2}</p>
                                </div>
                                <div className={cx(s.ListingbenefitsItem)}>
                                    <h3>{data && data.benefitsTitle3}</h3>
                                    <p>{data && data.benefitsContent3}</p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={5} md={4} sm={5} xs={12}>
                            <div className={s.ListingbenefitsImage}>
                                {/* <img src={benefitsImage} alt="Listing Benefits" className={cs.fullWidth} /> */}
                                <img src={'/images/home/' + data.benefitImage} className={cs.fullWidth} />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default withStyles(s, cs)(ListingBenefits); 